var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-pa-xl"},[_c('center',[_c('meta',{attrs:{"http-equiv":"refresh","content":"30;URL='/'"}}),_c('div',{staticClass:"fixed-center"},[_c('hi-logo',{attrs:{"size":"xxl","color":"white"}}),_c('h5',[_c('b',[_vm._v("Cannot connect to back-end")])]),_c('h6',[_vm._v("retrying in "+_vm._s(_vm.time)+" seconds")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }